import React from 'react';

// Common reusable components
import HelpVideo from '../HelpVideo';
import SliderWithVideo from '../SliderWithVideo';


const ApproveAT = () => {
    return(
        <div className="">
            <SliderWithVideo 
                idName="hub-projects"
                title="CMS Hub - Approval Team"
                video={<HelpVideo link="https://www.youtube.com/embed/xBcm3fIkirY" title="CMS Hub - Approval Team" />}
            >
                
            </SliderWithVideo>
        </div>
    );
};

export default ApproveAT;
